module.exports = __webpack_public_path__ + "img/23.fded6242.svg";